import React, { useContext } from "react";
import { IntlContext } from "../../pages/app/IntlContext";
import classNames from "classnames";
import "./styles.styl";

const LanguageSwitch = (props) => {
  const { switchToEnglish, switchToDeutsch } = useContext(IntlContext);
  const { currentLang } = props;
  return (
    <>
      <button
        onClick={switchToDeutsch}
        className={classNames("link-button", {
          underline: currentLang === "de",
        })}
      >
        Deutsch
      </button>
      {"|"}
      <button
        onClick={switchToEnglish}
        className={classNames("link-button", {
          underline: currentLang === "en",
        })}
      >
        English
      </button>
    </>
  );
};

export default LanguageSwitch;
